import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

class AngularMaterialModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: AngularMaterialModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.11", ngImport: i0, type: AngularMaterialModule, imports: [CommonModule,
            MatTreeModule,
            BrowserAnimationsModule,
            CdkTableModule,
            MatCheckboxModule,
            MatCheckboxModule,
            MatButtonModule,
            MatInputModule,
            MatAutocompleteModule,
            MatDatepickerModule,
            MatNativeDateModule,
            //MatMomentDatetimeModule,
            // MatDatetimepickerModule,
            MatFormFieldModule,
            MatRadioModule,
            MatSelectModule,
            MatDividerModule,
            MatSliderModule,
            MatSlideToggleModule,
            MatMenuModule,
            MatSidenavModule,
            MatToolbarModule,
            MatListModule,
            MatGridListModule,
            MatCardModule,
            MatStepperModule,
            MatTabsModule,
            MatExpansionModule,
            MatButtonToggleModule,
            MatChipsModule,
            MatIconModule,
            MatProgressSpinnerModule,
            MatProgressBarModule,
            MatDialogModule,
            MatTooltipModule,
            MatSnackBarModule,
            MatSortModule,
            MatPaginatorModule,
            MatRippleModule], exports: [MatTreeModule,
            BrowserAnimationsModule,
            CdkTableModule,
            MatCheckboxModule,
            MatCheckboxModule,
            MatButtonModule,
            MatInputModule,
            MatAutocompleteModule,
            MatDatepickerModule,
            //   MatDatetimepickerModule,
            MatBadgeModule,
            MatFormFieldModule,
            MatRadioModule,
            MatSelectModule,
            MatDividerModule,
            MatSliderModule,
            MatSlideToggleModule,
            MatMenuModule,
            MatSidenavModule,
            MatToolbarModule,
            MatListModule,
            MatGridListModule,
            MatCardModule,
            MatStepperModule,
            MatTabsModule,
            MatExpansionModule,
            MatButtonToggleModule,
            MatChipsModule,
            MatIconModule,
            MatProgressSpinnerModule,
            MatProgressBarModule,
            MatDialogModule,
            MatTooltipModule,
            MatSnackBarModule,
            MatTableModule,
            MatSortModule,
            MatPaginatorModule,
            MatRippleModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: AngularMaterialModule, imports: [CommonModule,
            MatTreeModule,
            BrowserAnimationsModule,
            CdkTableModule,
            MatCheckboxModule,
            MatCheckboxModule,
            MatButtonModule,
            MatInputModule,
            MatAutocompleteModule,
            MatDatepickerModule,
            MatNativeDateModule,
            //MatMomentDatetimeModule,
            // MatDatetimepickerModule,
            MatFormFieldModule,
            MatRadioModule,
            MatSelectModule,
            MatDividerModule,
            MatSliderModule,
            MatSlideToggleModule,
            MatMenuModule,
            MatSidenavModule,
            MatToolbarModule,
            MatListModule,
            MatGridListModule,
            MatCardModule,
            MatStepperModule,
            MatTabsModule,
            MatExpansionModule,
            MatButtonToggleModule,
            MatChipsModule,
            MatIconModule,
            MatProgressSpinnerModule,
            MatProgressBarModule,
            MatDialogModule,
            MatTooltipModule,
            MatSnackBarModule,
            MatSortModule,
            MatPaginatorModule,
            MatRippleModule, MatTreeModule,
            BrowserAnimationsModule,
            CdkTableModule,
            MatCheckboxModule,
            MatCheckboxModule,
            MatButtonModule,
            MatInputModule,
            MatAutocompleteModule,
            MatDatepickerModule,
            //   MatDatetimepickerModule,
            MatBadgeModule,
            MatFormFieldModule,
            MatRadioModule,
            MatSelectModule,
            MatDividerModule,
            MatSliderModule,
            MatSlideToggleModule,
            MatMenuModule,
            MatSidenavModule,
            MatToolbarModule,
            MatListModule,
            MatGridListModule,
            MatCardModule,
            MatStepperModule,
            MatTabsModule,
            MatExpansionModule,
            MatButtonToggleModule,
            MatChipsModule,
            MatIconModule,
            MatProgressSpinnerModule,
            MatProgressBarModule,
            MatDialogModule,
            MatTooltipModule,
            MatSnackBarModule,
            MatTableModule,
            MatSortModule,
            MatPaginatorModule,
            MatRippleModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.11", ngImport: i0, type: AngularMaterialModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MatTreeModule,
                        BrowserAnimationsModule,
                        CdkTableModule,
                        MatCheckboxModule,
                        MatCheckboxModule,
                        MatButtonModule,
                        MatInputModule,
                        MatAutocompleteModule,
                        MatDatepickerModule,
                        MatNativeDateModule,
                        //MatMomentDatetimeModule,
                        // MatDatetimepickerModule,
                        MatFormFieldModule,
                        MatRadioModule,
                        MatSelectModule,
                        MatDividerModule,
                        MatSliderModule,
                        MatSlideToggleModule,
                        MatMenuModule,
                        MatSidenavModule,
                        MatToolbarModule,
                        MatListModule,
                        MatGridListModule,
                        MatCardModule,
                        MatStepperModule,
                        MatTabsModule,
                        MatExpansionModule,
                        MatButtonToggleModule,
                        MatChipsModule,
                        MatIconModule,
                        MatProgressSpinnerModule,
                        MatProgressBarModule,
                        MatDialogModule,
                        MatTooltipModule,
                        MatSnackBarModule,
                        MatSortModule,
                        MatPaginatorModule,
                        MatRippleModule,
                        // MatMomentDateModule
                    ],
                    exports: [
                        MatTreeModule,
                        BrowserAnimationsModule,
                        CdkTableModule,
                        MatCheckboxModule,
                        MatCheckboxModule,
                        MatButtonModule,
                        MatInputModule,
                        MatAutocompleteModule,
                        MatDatepickerModule,
                        //   MatDatetimepickerModule,
                        MatBadgeModule,
                        MatFormFieldModule,
                        MatRadioModule,
                        MatSelectModule,
                        MatDividerModule,
                        MatSliderModule,
                        MatSlideToggleModule,
                        MatMenuModule,
                        MatSidenavModule,
                        MatToolbarModule,
                        MatListModule,
                        MatGridListModule,
                        MatCardModule,
                        MatStepperModule,
                        MatTabsModule,
                        MatExpansionModule,
                        MatButtonToggleModule,
                        MatChipsModule,
                        MatIconModule,
                        MatProgressSpinnerModule,
                        MatProgressBarModule,
                        MatDialogModule,
                        MatTooltipModule,
                        MatSnackBarModule,
                        MatTableModule,
                        MatSortModule,
                        MatPaginatorModule,
                        MatRippleModule,
                        // MatMomentDateModule
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AngularMaterialModule };
